import { IBasicReturn } from '@interfaces/IBasicReturn';
import AppAxiosInstance from './appAxiosInstance';

const onLogout = async (): Promise<IBasicReturn> => {
  let logoutResult: IBasicReturn = {
    Success: true,
  };

  await AppAxiosInstance()
    .get<IBasicReturn>('Identity/SignOut')
    .then((response): IBasicReturn => {
      const { data } = response;

      logoutResult = data;

      return logoutResult;
    })
    .catch((): IBasicReturn => {
      logoutResult.Success = false;

      return logoutResult;
    });

  return logoutResult;
};

export default onLogout;
